import { SoStatusEnum } from "@gtpl/shared-models/common-models";
import { ApiProperty } from "@nestjs/swagger";

export class ExpensesLogisticsDto{
    @ApiProperty()
    expensesLogisticsId: number;
    @ApiProperty()
    saleOrderId: number;
    @ApiProperty()
    chaBill:number;
    @ApiProperty()
    oceanFrieght: number;
    @ApiProperty()
    domesticFrieght: number;
    @ApiProperty()
    salesComission: number;
    @ApiProperty()
    antiDumpingDuty: number;
    @ApiProperty()
    cvd: number;
    @ApiProperty()
    clearingForwarding: number;
    @ApiProperty()
    ddpTransport: number;
    @ApiProperty()
    marineInsurance: number;
    @ApiProperty()
    amc: number;
    @ApiProperty()
    dutyDrawback: number;
    @ApiProperty()
    rodtepAmount: number;
    @ApiProperty()
    fdaDueDate: string;
    @ApiProperty()
    remarks: string;
    @ApiProperty()
    isActive?: boolean;
    @ApiProperty()
    createdUser?: string | null;
    @ApiProperty()
    updatedUser?: string | null;
}